import * as React from 'react';
import { routingEnabled } from 'utils/ui/app';

import HeaderWithCallback, { IHeaderProps } from './Header';
import HeaderWithRouting from './Container';

const AutoHeader: React.FC<IHeaderProps> = (props) => {
  return routingEnabled() ? <HeaderWithRouting {...props} /> : <HeaderWithCallback {...props} />;
};

export default AutoHeader;
